module.exports = __webpack_public_path__ + "img/facebook.89425d3a.svg";